import { cn } from '@/lib/utils';
import { formatAssistantText, type AssistantTextSegment } from './formatAssistantText';

function renderSegments(segments: AssistantTextSegment[]) {
  return segments.map(function renderSegment(segment, index) {
    if (segment.isBold) {
      return (
        <strong key={index} className="font-semibold text-zooindigo">
          {segment.text}
        </strong>
      );
    }
    if (segment.isItalic) {
      return <em key={index}>{segment.text}</em>;
    }
    return <span key={index}>{segment.text}</span>;
  });
}

interface AssistantFormattedTextProps {
  text: string;
  isStreaming: boolean;
}

export function AssistantFormattedText({ text, isStreaming }: AssistantFormattedTextProps) {
  const blocks = formatAssistantText(text);
  return (
    <div className={cn('text-sm text-zooindigo leading-relaxed space-y-2.5 break-words')}>
      {blocks.map(function renderBlock(block, blockIndex) {
        if (block.kind === 'paragraph') {
          return <p key={blockIndex}>{renderSegments(block.segments)}</p>;
        }
        if (block.kind === 'orderedList') {
          return (
            <ol key={blockIndex} className="space-y-1.5">
              {block.items.map(function renderItem(item, itemIndex) {
                return (
                  <li key={itemIndex} className="flex gap-2.5">
                    <span className="w-5 h-5 rounded-full bg-zoovpalelavender text-zooprimary text-[11px] font-bold flex items-center justify-center shrink-0 mt-0.5">
                      {itemIndex + 1}
                    </span>
                    <span>{renderSegments(item)}</span>
                  </li>
                );
              })}
            </ol>
          );
        }
        return (
          <ul key={blockIndex} className="list-disc pl-5 space-y-1">
            {block.items.map(function renderItem(item, itemIndex) {
              return <li key={itemIndex}>{renderSegments(item)}</li>;
            })}
          </ul>
        );
      })}
      {isStreaming ? (
        <span className="inline-block w-1.5 h-3.5 bg-zooprimary rounded-sm align-middle motion-safe:animate-pulse" />
      ) : null}
    </div>
  );
}
